

































import { defineComponent, ref, useFetch } from '@nuxtjs/composition-api';
import { SfButton, SfSearchBar } from '@storefront-ui/vue';
import { debounce } from 'lodash-es';
import { useApi } from '~/composables';
import { buildSeoHead } from '~/helpers/buildSeoHead';
import ClinicsGoogleMaps from '~/modules/clinics/components/ClinicsGoogleMaps.vue';
import ClinicsList from '~/modules/clinics/components/ClinicsList.vue';
import SvgImage from '../../../components/General/SvgImage.vue';
import clinicsGql from '../queries/clinics.gql';
import { Clinic, ClinicsQuery } from '../types';

export default defineComponent({
  name: 'SamplingSites',
  components: { ClinicsGoogleMaps, ClinicsList, SfSearchBar, SfButton, SvgImage },
  setup() {
    const { query } = useApi();
    const clinics = ref<Clinic[]>([]);
    const allClinics = ref<Clinic[]>([]);

    const searchInput = ref('');
    const minTermLen = 2;

    useFetch(async () => {
      const { data } = await query<ClinicsQuery>(clinicsGql);
      clinics.value = data.clinics?.items;
      allClinics.value = data.clinics?.items;
    });

    const rawHandleSearch = async (searchTerm: string) => {
      searchInput.value = searchTerm;
      if (searchInput.value.length === 0) {
        clinics.value = allClinics.value;
        return;
      }
      if (searchTerm.length < minTermLen) return;
      const { data } = await query<ClinicsQuery>(clinicsGql, { search: searchTerm });

      clinics.value = data.clinics?.items;
    };

    const debouncedHandleSearch = debounce(rawHandleSearch, 500);

    const handleKeydownEnter = (searchTerm: string) => {
      // cancel debounce timeout started by typing into the searchbar - this is to avoid making two network requests instead of one
      debouncedHandleSearch.cancel();
      rawHandleSearch(searchTerm);
    };

    const cancelSearch = () => {
      debouncedHandleSearch.cancel();
      searchInput.value = '';
      clinics.value = allClinics.value;
    };

    return {
      clinics,
      searchInput,
      debouncedHandleSearch,
      handleKeydownEnter,
      cancelSearch,
    };
  },
  head: buildSeoHead({ title: 'Här finns vi' }),
});
